import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const SearchPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const query = new URLSearchParams(location.search).get("q")?.toLowerCase() || "";

  const navItems = [
    { label: "Proctology", items: ["Piles","Fistula","Fissure","Rectal Treatment"] },
    { label: "Laparoscopy", items: ["Femoral hernia","Incisional hernia","Hiatal hernia","Appendicitis","Umbilical hernia","Inguinal hernia","Hysterectomy"] },
    { label: "Urology", items: ["Circumcision","Stapler Circumcision","Laser Circumcision","Phimosis","Balanoposthitis","PCNL","RIRS","URSL","Hydrocele","Enlarged prostate","Frenuloplasty surgery","Kidney stones treatment","Foreskin infection","Prostatectomy"] },
    { label: "Gynecology", items: ["MTP","PCOD-PCOS"] },
    { label: "Aesthetics", items: ["Gynecomastia","Lipoma"] },
    { label: "ENT", items: ["Turbinate Reduction","Nasal polyps","Vocal Cord polyps","Ear Surgery","Throat Surgery","Myringotomy","Stapedectomy","Tonsillectomy","Thyroidectomy","Fess Surgery","Mastoidectomy","Septoplasty","Sinus treatment","Adenoidectomy"] },
    { label: "Fertility", items: ["IUI treatment","IVF treatment","Male fertility","Female infertility","Egg freezing"] },
    { label: "Orthopedics", items: ["Total knee replacement","Shoulder arthroscopy","Knee Arthroscopy","Arthroscopy surgery","Rotator cuff repair","Shoulder replacement","Meniscus tear treatment","ACL tear treatment","Carpal tunnel syndrome","Knee Replacement"] },
    { label: "Weight Loss", items: ["Bariatric surgery"] }
  ];

  const formatPath = (text) => "/" + text.toLowerCase().replace(/\s+/g, "-");

  const results = [];

  navItems.forEach(cat => {
    cat.items.forEach(item => {
      if (item.toLowerCase().includes(query)) {
        results.push(item);
      }
    });
  });

  // ✅ AUTO REDIRECT IF EXACT MATCH
  useEffect(() => {
    const exact = results.find(item => item.toLowerCase() === query);
    if (exact) {
      navigate(formatPath(exact));
    }
  }, [query]);

  return (
    <div style={{ padding: "100px 20px" }}>
      <h2>Search Results for: "{query}"</h2>

      {results.length === 0 ? (
        <p>No results found 😢</p>
      ) : (
        <div style={{ marginTop: "20px" }}>
          {results.map((item, i) => (
            <div
              key={i}
              style={{
                padding: "12px",
                border: "1px solid #ddd",
                marginBottom: "10px",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "0.3s"
              }}
              onClick={() => navigate(formatPath(item))}
              onMouseOver={(e) => e.currentTarget.style.background = "#f5f5f5"}
              onMouseOut={(e) => e.currentTarget.style.background = "#fff"}
            >
              {item}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchPage;